import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent {
  @Input() name: string;
  @Input() color: string;
  @Input() useDefault = false;
  @Input() class: string;

  constructor() { }

}
